import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Login from './views/pages/Login';
import Profile from './views/pages/Profile';
import ManageApiKey from './views/pages/ManageApiKey';
import Clients from './views/pages/Clients';
import CreateClient from './views/pages/CreateClient';
import UnitsList from './views/pages/UnitsList';
import CreateUnit from './views/pages/CreateUnit';
import AccessLog from './views/pages/AccessLog';
import EditUnit from './views/pages/EditUnit';
import { RequireToken } from './views/components/Auth';
// import logo from './logo.svg';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './style/bootstrap-custom.scss';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import './App.css';
import './style/index.scss';

import Header from './views/components/Header';

import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
config.autoAddCss = false;

function App() {
  let location = useLocation();

  return (
    <>
      <div className="App gatito-app">
        {/* <main> */}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            exact
            path="/"
            element={
              <RequireToken
                roles="super-user"
                notAuthorized={
                  <>
                    <Navigate to="/self" state={{ from: location }} />
                  </>
                }
              >
                <Clients />
              </RequireToken>
            }
          />
          <Route path="clients">
            <Route
              path="new"
              element={
                <RequireToken
                  roles="super-user"
                  notAuthorized={
                    <>
                      <Navigate to="/" state={{ from: location }} />
                    </>
                  }
                >
                  <CreateClient />
                </RequireToken>
              }
            />
            <Route path=":clientId">
              <Route
                exact
                path=""
                element={
                  <RequireToken
                    roles="super-user"
                    notAuthorized={
                      <>
                        <Navigate to="/" state={{ from: location }} />
                      </>
                    }
                  >
                    <Profile />
                  </RequireToken>
                }
              />
              <Route
                exact
                path="key"
                element={
                  <RequireToken
                    roles="super-user"
                    notAuthorized={
                      <>
                        <Navigate to="/" state={{ from: location }} />
                      </>
                    }
                  >
                    <ManageApiKey />
                  </RequireToken>
                }
              />
              <Route path="units">
                <Route
                  exact
                  path=""
                  element={
                    <RequireToken
                      roles="super-user"
                      notAuthorized={
                        <>
                          <Navigate to="/" state={{ from: location }} />
                        </>
                      }
                    >
                      <UnitsList />
                    </RequireToken>
                  }
                />
                <Route
                  path="new"
                  element={
                    <RequireToken
                      roles="super-user"
                      notAuthorized={
                        <>
                          <Navigate to="/" state={{ from: location }} />
                        </>
                      }
                    >
                      <CreateUnit />
                    </RequireToken>
                  }
                />
                <Route
                  path=":unitId"
                  element={
                    <RequireToken
                      roles="super-user"
                      notAuthorized={
                        <>
                          <Navigate to="/" state={{ from: location }} />
                        </>
                      }
                    >
                      <AccessLog />
                    </RequireToken>
                  }
                />
                <Route
                  path=":unitId/edit"
                  element={
                    <RequireToken
                      roles="super-user"
                      notAuthorized={
                        <>
                          <Navigate to="/" state={{ from: location }} />
                        </>
                      }
                    >
                      <EditUnit />
                    </RequireToken>
                  }
                />
              </Route>
            </Route>
          </Route>
          <Route
            path="units/:unitId"
            element={
              <RequireToken>
                <AccessLog />
              </RequireToken>
            }
          />
          <Route path="self">
            <Route
              path=""
              element={
                <RequireToken>
                  <UnitsList mode="self" />
                </RequireToken>
              }
            />
            <Route
              path="new"
              element={
                <RequireToken>
                  <CreateUnit mode="self" />
                </RequireToken>
              }
            />
            <Route
              exact
              path="info"
              element={
                <RequireToken>
                  <Profile mode="self" />
                </RequireToken>
              }
            />
            <Route
              path=":unitId"
              element={
                <RequireToken>
                  <AccessLog mode="self" />
                </RequireToken>
              }
            />
            <Route
              path=":unitId/edit"
              element={
                <RequireToken>
                  <EditUnit mode="self" />
                </RequireToken>
              }
            />
          </Route>
        </Routes>
        {/* </main> */}
      </div>
    </>
  );
}

export default App;
